<template>
  <artmisads-modal
    :visible.sync="visible"
    :title="title"
    width="500px"
    @cancel="visible = false"
    :maskClosable="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div>
   
      <a-form
    :model="formState"
    :loading="loading"
    name="basic"
   :label-col="{ span: 5 }"
    autocomplete="off"
    ref="formRef"
  >
    <a-form-item
      label="输入邮箱"
      name="userEmail"
      :rules="[{ required: true, message: '请输入邮箱' }
     ]"
    >
    <a-select
    v-model:value="formState.userEmail"
    show-search
    :disabled="disabled"
    allowClear
    style="width: 100%"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="null"
    :options="options"
    @search="onSearch"
    @change="onSelect"
    :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
  ></a-select>
     <!-- <a-auto-complete
          class="autoComplete"
          :disabled="disabled"
            v-model:value="formState.userEmail"
            :options="options"
            style="width: 100%;height: 32px;"
            size="large"
            @search="onSearch"
            @select="onSelect"
            allow-clear
            @clear="onResetComplete"
          
            :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
          >
          </a-auto-complete> -->
    </a-form-item>

    <a-form-item
      label="选择站点"
      name="marketplace"
      :rules="[{ required: true, message: '请选择站点' }]"
    >
      <div ref="marketplaceRef"> 
        <artmisads-select
        :allowClear="true"
         :disabled="disabled"
            style="width: 100%"
            v-model:value="formState.marketplace"
            :getPopupContainer="() => marketplaceRef"
            :options="COUNTRY_BASE_OPTIONS"
            @change="onMarketplaceChange"
          />
      </div>
    </a-form-item>

    <a-form-item  label="调整方式"
      name="adjustmentType"
      :rules="[{ required: true, message: '请选择调整方式' }]"
      @change="onAdjustmentChange"
      >
    <div ref="adjustmentRef">
       <artmisads-select
        :allowClear="true"
        :disabled="disabled"
            style="width: 100%"
            v-model:value="formState.adjustmentType"
            :getPopupContainer="() => adjustmentRef"
            :options="adjustmentOptions"
            @change="onAdjustmentChange"
          />
    </div>
    </a-form-item>
    <a-form-item
      label="调整值"
      name="adjustmentValue"
      :rules="[{ required: true, message: '请输入调整值' }]"
    >
    <!-- FixedAmountAdd
PercentageAdd -->
      <a-input-number
       :disabled="disabled"
       :allowClear="true"
      v-model:value="formState.adjustmentValue"
      type="number"
      :min="0"
      style="width: 100%"
      :max="formState.adjustmentType === 'FixedAmountAdd'||formState.adjustmentType === 'FixedAmountDecrease' ? 10000 : 100"
      :addonAfter="formState.adjustmentType === 'FixedAmountAdd'||formState.adjustmentType === 'FixedAmountDecrease' ? '$' : '%'"/>
    </a-form-item>
    <a-form-item
    
      label="备注"
      name="adjustmentReason"
      
    >
      <a-textarea 
    :allowClear="true"
       :disabled="disabled" v-model:value="formState.adjustmentReason" type="textarea" />
    </a-form-item>
    
  </a-form>
    </div>
    <template #footer>
      <div class="footer">
        <artmisads-button isSquare="true" @click="visible = false">取消</artmisads-button>
        <artmisads-button isSquare="true" type="primary" @click="onSubmit">确定</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
</template>
<script setup >
import { min } from 'lodash'
import { ref ,defineExpose,onMounted,defineEmits} from 'vue'
import { COUNTRY_BASE } from "~/contants/common";
import { financeApi } from "~/server/operator/finance"
import {message} from 'ant-design-vue'
const marketplaceRef = ref(null);
const adjustmentRef = ref(null);
const formRef = ref(null);
const visible = ref(false)
const disabled= ref(false)
const loading= ref(false)
const title=ref('新建手动支付')
const type= ref('')
const emits = defineEmits(['submit']);
const formState = ref({
  userEmail: '',
  marketplace: '',
  adjustmentType: '',
  adjustmentValue: '',
  adjustmentReason: '',
})
const parmas=ref({
  id:'',
  userId:'',
  marketplace:"",
  adjustmentType:"",
  adjustmentValue:"",
  adjustmentReason:"",
})
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host;
  item.label = item.host;
  return item;
});
const options=ref([])
const userInfoArr=ref([])
const _options=[];
const adjustmentOptions=ref([
  {
    label: '固定金额增加',
    value: 'FixedAmountAdd',
  },
  {
    label: '固定金额减少',
    value: 'FixedAmountDecrease',
  },
  {
    label: '百分比金额增加',
    value: 'PercentageAdd',
  },
  {
    label: '百分比金额减少',
    value: 'PercentageDecrease',
  }
])
const onMarketplaceChange = (value) => {
  formState.value.marketplace = value;
};
const onAdjustmentChange = (value) => {
  formState.value.adjustmentType = value;
  if(value === 'FixedAmountAdd' || value === 'FixedAmountDecrease'){
    parmas.value.adjustmentType='FIXED_AMOUNT'
  }
  else{
    parmas.value.adjustmentType='PERCENTAGE'
  }
};
const onSubmit=async()=>{
    formRef.value.validate().then( res=>{
    parmas.value.marketplace=formState.value.marketplace;
    parmas.value.adjustmentReason=formState.value.adjustmentReason;
    if(formState.value.adjustmentType === 'FixedAmountAdd' || formState.value.adjustmentType === 'FixedAmountDecrease'){
      parmas.value.adjustmentType='FIXED_AMOUNT'
    }
    else{
      parmas.value.adjustmentType='PERCENTAGE'
    }
    if(formState.value.adjustmentType === 'FixedAmountAdd' || formState.value.adjustmentType === 'PercentageAdd'){
      parmas.value.adjustmentValue=Number(formState.value.adjustmentValue);
    }
    else{
      parmas.value.adjustmentValue=-Number(formState.value.adjustmentValue);
    }
    if(type.value === 'add'){
      delete parmas.value.id
    financeApi.addManualAdjustment(parmas.value).then(res=>{
   
    if(res.success){
      message.success('创建成功');
      visible.value = false
      formRef.value.resetFields();
      emits('submit');
    }
    else{
      message.error('调整失败');
    }
    })
    }else{
      financeApi.updateManualPayment(parmas.value).then(res=>{
        if(res.success){
          message.success('更新成功');
          visible.value = false
          formRef.value.resetFields();
          emits('submit');
        }
        else{
          message.error('更新失败');
        }
      })
    }

        // ElMessage.success('调整成功');
        // visible.value = false
        // formRef.value.resetFields();
    
  })

}
const onSearch=e=>{
  const parma={
    email:e,
  }
  getUser(parma)
}
const onSelect=e=>{
  const res=userInfoArr.value.find(v=>v.userId == e);
  formState.value.userEmail=res.email;
  parmas.value.userId=res.userId;

}

const getUser=async(parma)=>{
  const res=await financeApi.getUserInfo(parma)
  options.value=res.map(item=>({
    label: item.email,
    value: item.userId,
  }))
  userInfoArr.value=res
}
onMounted(()=>{

})
defineExpose({
  show(params) {
   
    type.value=params.type
    if(params.type === 'add'){
      title.value='新建手动支付'
      params.value={
        id:'',
        userId:'',
        marketplace:"",
        adjustmentType:"",
        adjustmentValue:"",
        adjustmentReason:"",
      }
      setTimeout(()=>{
        formRef.value.resetFields();
      },0)
      disabled.value=false
    }
    if(params.type === 'view'||params.type === 'edit'){
       loading.value=true
      if(params.type === 'view'){
        disabled.value=true
        title.value='查看手动支付'
      }else{
        disabled.value=false
        title.value='编辑手动支付'
      }
      financeApi.getManualPaymentsById({id:params.id}).then(res=>{
        if(res){
          formState.value.userEmail=res.userEmail;
          formState.value.marketplace=res.marketplace;
          if(res.adjustmentType){
            if(res.adjustmentType === 'FIXED_AMOUNT'){
              if(res.adjustmentValue>0){
                formState.value.adjustmentType='FixedAmountAdd'
              }
              else{
                formState.value.adjustmentType='FixedAmountDecrease'
              }
            }
            else{
              if(res.adjustmentValue>0){
                formState.value.adjustmentType='PercentageAdd'
              }
              else{
                formState.value.adjustmentType='PercentageDecrease'
              }
            }
          }
          parmas.value.userId=res.userId;
          parmas.value.id=res.id;
          // formState.value.adjustmentType=res.adjustmentType;
          formState.value.adjustmentValue=Math.abs(res.adjustmentValue);
          formState.value.adjustmentReason=res.adjustmentReason;
        }
      }).finally(()=>{
        loading.value=false
      })
    }
    visible.value = true
    // getUser()
  },
})
</script>
<style scoped lang="less">
.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
   
  }
   :deep(.ant-select-selection-search-input){
       height: 32px !important;
    }
    :deep(.ant-select-selection-placeholder){
      line-height: 32px !important;
    }
}
</style>